import { render, staticRenderFns } from "./XmlViewer.vue?vue&type=template&id=57d25e35"
import script from "./XmlViewer.vue?vue&type=script&lang=js"
export * from "./XmlViewer.vue?vue&type=script&lang=js"
import style0 from "./XmlViewer.vue?vue&type=style&index=0&id=57d25e35&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports